export default "__VITE_ASSET__Bq65hLFa__"